<template>
  <v-dialog
    v-model="isDialog"
    light persistent
    fullscreen
  >
    <v-card v-if="isDialog">

      <div class="thisDialog text-center" style="height: var(--layout-height)">

        <div class="superCenter">
          <div class="text-center">

            <div style="max-width: 305px; display: inline-block">
              <h2>{{ codeTitle }}</h2>
              <h4 v-if="codeSubtitle">{{ codeSubtitle }}</h4>
              <!--            <div>DEBUG acceptableCodes: {{ JSON.stringify(acceptableCodes) }}</div>-->
              <div class="mt-6">
                <v-text-field v-if="$store.getters.isAndroidKiosk"
                              readonly
                              inputmode="none"
                              :input-props="{ inputmode: 'none' }"
                              @focus="codeFocus"
                              autofocus
                              prepend-inner-icon="mdi-lock" outlined v-model="theCode"
                              label="Enter your code" required full-width
                              clearable
                              class="roundInput">
                </v-text-field>
                <v-text-field v-else
                              prepend-inner-icon="mdi-lock" outlined v-model="theCode"
                              autofocus
                              label="Enter your code" required full-width
                              clearable
                              class="roundInput">
                </v-text-field>
                <!--            :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"-->
                <!--            :type="show1 ? 'text' : 'password'"-->
                <!--            @click:append="show1 = !show1"-->
              </div>
              <div class="text-center">
                <v-btn class="text-none btn-df mt-3" rounded color=" primary"
                       @click.native.passive.stop="goAhead('button')">
                  Confirm
                </v-btn>
              </div>
              <div class="text-center">
                <v-btn class="text-none mt-3" rounded color="primary"
                       @click.native.passive.stop="handleDismiss">
                  CANCEL
                </v-btn>
              </div>
            </div>

          </div>
        </div>
      </div>

    </v-card>

    <div v-if="showPinInput" class="fixedVirtualKeyboard">
      <div class="superCenter">
        <VirtualPinInput
          :label="pinInputLabel"
          @enter="pinInputEnter"
          @close="showPinInput = false"
        ></VirtualPinInput>
      </div>
    </div>

  </v-dialog>
</template>

<script>
import store from '@/store/store';
import {ebus} from '../vendor/ebus';
import {lsWrapper} from "@/util/globalErrorHandler";
import VirtualPinInput from "../components/VirtualPinInput.vue";

export default {
  components: {VirtualPinInput},
  props: {
    dialog: Boolean,
    acceptableCodes: {
      type: Array,
      default: () => [],
    },
    codeTitle: {
      type: String,
      default: 'Code'
    },
    codeSubtitle: {
      type: String,
      default: ''
    },
    c: {
      type: String,
      default: '9999'
    },
    withRemark: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      isDialog: false,

      theCode: '',
      show1: false,

      showPinInput: false,
      pinInputLabel: '',

    }
  },
  watch: {
    dialog(newValue) {
      this.clear();
      if (newValue && this.isDialog) {
        // this.isDialog= false;
      }
      this.isDialog = newValue;
      if (newValue) {
        if (store.getters.isAndroidKiosk) {
          this.codeFocus();
        }
        this.addEnterListener();
      }
    },
    isDialog(newValue) {
      this.clear();
      if (!newValue) {
        this.removeEnterListener();
        // this.ready = false;
        this.clear();
        this.$emit('close');
      }
    },
    submitterRemark(newValue) {
      this.lazyShortenSubmitterRemark();
    },
  },
  mounted() {
    this.clear();
  },
  destroyed() {

  },

  methods: {
    pinInputEnter(text) {
      if (text) {
        this.theCode = text;
        this.goAhead('pinInputEnter');
      }
    },
    codeFocus() {
      console.log('codeFocus');
      this.pinInputLabel = this.codeTitle;
      this.showPinInput = true;
    },
    clear() {
      this.theCode = '';
      this.showPinInput = false;
      this.$nextTick(() => {
        this.showPinInput = true;
      });
    },
    onBlur() {
      this.lazyShortenSubmitterRemark()
    },
    lazyShortenSubmitterRemark() {
      this.$nextTick(() => {
        let v = this.submitterRemark;
        if (v.length > 250) {
          ebus.$emit('toast', 'Maximum 250 characters allowed');
          this.submitterRemark = v.slice(0, 250)
        }
      });
    },
    addEnterListener() {
      window.addEventListener('keyup', this.enterKey);
    },
    removeEnterListener() {
      try {
        if (this.enterKey) {
          window.removeEventListener('keyup', this.enterKey);
        }
      } catch (e) {

      }
    },
    enterKey(event) {
      if (this.$store.getters.isAndroidKiosk) {
        return;
      }
      if (event.keyCode === 13) {
        let exp = 3 * 1000;//expiry 30 minutes
        lsWrapper.set('silentCode', true, exp);
        this.$nextTick(() => {
          this.goAhead('key');
        });
      }
    },
    // clickNum(_num) {
    //   if (this.num === '&nbsp;') {
    //     this.num = _num;
    //   } else if (this.num.length < 4) {
    //     this.num += _num;
    //   }
    // },
    // reset() {
    //   this.num = '&nbsp;';
    // },
    closeDialog() {
      this.clear();
      this.isDialog = false;
      // this.$emit('close');//no
    },
    goAhead(source) {
      console.log('goAhead... from ' + source);
      let validCodes = [];

      if (this.acceptableCodes?.length) {
        this.acceptableCodes.forEach(c => {
          if (c) {
            validCodes.push(c);
          }
        })
      }

      setTimeout(() => {
        if (this.theCode.length >= 4 && validCodes.includes(this.theCode)) {
          this.$emit('validationSuccess', '' + this.theCode);
          this.closeDialog();
        } else {
          console.log('The entered code is invalid: ' + this.theCode);
          ebus.$emit('toast', 'The entered code is invalid');
        }
        // this.$emit('codeSelected', '' + this.num);
      }, 50);
    },
    handleDismiss() {
      this.closeDialog();
    }
  },
}
</script>

<style lang="scss" scoped>
@import '../styles/base';

.thisDialog {
  /*<!--background-color: rgba($color-primary, 0.95);-->*/


  /*position: fixed;*/
  /*z-index: 180;*/
  /*top: 0;*/
  /*left: 0;*/
  /*height: 100%;*/
  /*width: 100%;*/
}

.lengthHint {
  text-align: left;
  padding-left: 5px;
}

.orderbemerkungBox {
  margin: 0 25px 25px 25px;
}

.orderremark-textarea-width {
  min-width: 500px;
  max-width: 500px;
  width: 100%;
}

.ntable {
  td {
    width: 33.33%;
    text-align: center;
    padding: 8px;
  }
}

.num {
  display: inline-block;
  background-color: black;
  color: white;
  font-size: 1.5em;
  border-radius: 8px;
  width: 50px;
  height: 50px;
  padding: 8px;


  @include material-shadow(2);
}

.displayTischnummer {
  font-size: 2.5rem;
  font-weight: bold;
  color: black;
  min-width: 100px;
  border-bottom: 1px solid black;
  /*height: 73px;*/
}

.vdevice-xs {
  .ntable {
    td {
      padding: 6px;
    }
  }

  .num {
    font-size: 1.2em;
    width: 40px;
    height: 40px;
  }

  .displayTischnummer {
    font-size: 2rem;
  }
}

/*.vvd{*/
/*    >>> .v-dialog{*/
/*        position: absolute;*/
/*    }*/
/*}*/
</style>
